import { useCallback, useEffect, useState } from 'react';

import { AutoComplete, AutoCompleteProps } from 'primereact/autocomplete';

import { useLazySearchSiresLookupQuery } from '@/app/services/lookups';
import { MIN_SEARCH_LENGTH, SELECTION_LIMIT } from '@/constants';
import { Sire } from '@/rtk-query.gql';

import './SireAutoComplete.css';

type SireAutoCompleteProps = AutoCompleteProps & {
  className?: string;
  label?: string;
  defaultValue?: Sire;
};

export const SireAutoComplete = ({
  className,
  label,
  defaultValue,
  ...autoCompleteProps
}: SireAutoCompleteProps) => {
  const [selected, setSelected] = useState<Sire | undefined>(defaultValue);
  const [filtered, setFiltered] = useState<Sire[]>([]);
  const [inputValue, setInputValue] = useState(defaultValue?.name);

  const [query] = useLazySearchSiresLookupQuery();

  useEffect(() => {
    setSelected(defaultValue);
    setInputValue(defaultValue?.name || '');
  }, [defaultValue]);

  const search = useCallback(
    async (event: { query: string }) => {
      const { data = [] } = await query({
        search: event.query || '',
        selectionLimit: SELECTION_LIMIT,
      });

      setFiltered(data);
    },
    [query],
  );

  const handleSelect = (e: { value: Sire }) => {
    setSelected(e.value);
    if (setInputValue) {
      setInputValue(e.value?.name as string);
    }
  };

  const handleChange = (e: { value: string }) => {
    if (setInputValue) {
      setInputValue(e.value as string);
    }
  };

  return (
    <div
      className={`[ sire-auto-complete ] [${className ? ` ${className}` : ''} label-input-group ]`}
    >
      {label && <label>{label}</label>}
      <AutoComplete
        appendTo="self"
        suggestions={filtered}
        minLength={MIN_SEARCH_LENGTH}
        selectionLimit={SELECTION_LIMIT}
        completeMethod={search}
        onSelect={handleSelect}
        onChange={handleChange}
        dropdown={true}
        {...autoCompleteProps}
        value={inputValue}
      />
    </div>
  );
};
